<div class="folder-overview-footer">
  <div class="flex items-center gap-4">
    <button
      (click)="openExportModal()"
      class="scope-output">
      <i class="material-symbols-rounded">download</i>
      <span>Output</span>
    </button>

    <button
      class="scope-traffic"
      *ngIf="folderOverviewService.isTrafficable"
      [disabled]="false"
      [class.disabled]="false"
      (click)="openTrafficModal()">
      <i class="material-symbols-rounded">swap_vert</i>
      <span>Traffic</span>
    </button>
  </div>
</div>
